/**
 * Locale-aware price formatting for the marketing and activation surfaces.
 *
 * Each app language maps to the locale whose currency conventions its
 * audience expects: "$9.99" (en), "R$ 30" (pt), "7,99 €" (es/fr/de/it).
 * Ukrainian (uk) is priced in hryvnia: "250 ₴" (uk-UA puts the symbol after the amount).
 */
const LOCALES: Record<string, string> = {
  en: "en-US",
  pt: "pt-BR",
  es: "es-ES",
  fr: "fr-FR",
  de: "de-DE",
  it: "it-IT",
  uk: "uk-UA",
};

export function formatPrice(amount: number, currency: string, lang: string, symbol?: string): string {
  const digits = Number.isInteger(amount) ? 0 : 2;
  try {
    return new Intl.NumberFormat(LOCALES[lang] ?? "en-US", {
      style: "currency",
      currency,
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    }).format(amount);
  } catch {
    // Unknown ISO code typed in the admin: fall back to the admin-provided symbol.
    const s = digits === 0 ? String(amount) : lang === "en" ? amount.toFixed(2) : amount.toFixed(2).replace(".", ",");
    return `${symbol ?? currency} ${s}`;
  }
}
